import resultsReviewDispatcher from '../action';

const initialState = {
  list: [],
  paging: {
    pageIndex: 0,
    pageSize: 10,
    totalItem: 0,
    totalPage: 0,
  },
};

const resultsReviewReducer = resultsReviewDispatcher(initialState, {
  [resultsReviewDispatcher.getDataSuccess]: (state, payload) => ({
    list: payload.data.list,
    paging: {
      ...payload.data,
      list: undefined,
    },
  }),
  [resultsReviewDispatcher.setState]: (state, payload) => ({
    [payload.state]: payload.value,
  }),
  [resultsReviewDispatcher.resetData]: (state, _) => ({
    ...initialState,
  }),
});

export default resultsReviewReducer;
